import React,{ useState, useRef } from 'react'; 
import { Link, useHistory } from 'react-router-dom';
import { Form, InputGroup} from 'react-bootstrap'    
import { useSelector, useDispatch } from "react-redux";
import ToastErrorMessage from '../Components/ToastErrorMessage'
import PhoneInput, { isValidPhoneNumber  } from 'react-phone-number-input'

function Register(props) { 

    const {apiData} = useSelector(state => state);
    const history = useHistory();
    const dispatch = useDispatch();
    const [formValidated, setFormValidate] = useState(false);
    const [showPassword, passwordChange] = useState(false);
    const [emailEntered, emailOnChange] = useState(false); 
    const [privacyPolicyError, setPrivacyPolicyError] = useState(false);
    const [phoneNumber, setPhoneNumber] = useState();

    const [titleList, setTitleList] = useState([
        'Aerospace Medicine',
        'Anaesthesia',
        'Bariatric Surgery',
        'Cardiology - Interventional',
        'Cardiology - Non Interventional',
        'Cardiothoracic And Vascular Surgery',
        'Centre For Spinal Diseases',
        'Clinical Haematology And BMT',
        'Corneal Transplant',
    ]);
    const [title, selectTitle] = useState('Select Title*');
    const [titlePopup, changeTitlePopup] = useState(false);
    const [titleError, setTitleError] = useState(false);

    const firstNameInput = useRef(); 
    const emailInput = useRef(); 
    const passwordInput = useRef();
    const privacyPolicAcceptInput = useRef();

    //submit function
    let formSubmit = (event) => {
        const form = event.currentTarget; 
        event.preventDefault(); 

        if (form.checkValidity() === false || title == 'Select Title*') { 
            if(title === 'Select Title*'){
                setTitleError(true)
            }
            setFormValidate(true)
            event.preventDefault(); 
            event.stopPropagation();

            if(!privacyPolicAcceptInput.current.checked){
                setPrivacyPolicyError(true)
            }

        } 

     
        if(!isValidPhoneNumber(phoneNumber)){
            setFormValidate(true)
            event.preventDefault(); 
            event.stopPropagation();
            return false;
        }

        if(form.checkValidity() === true){ 
            let data = {
                first_name: firstNameInput.current.value,
                email: emailInput.current.value,
                mobile_number: phoneNumber,
                password: passwordInput.current.value, 
                designation: title, 
            }
            dispatch({ type: "API_LOADER_START" }) 
            dispatch({
                type: "REGISTER_API_CALL",
                payload: data
            }) 
        }
        
    }

    //toggle password
    let passwordToggle = () => {
        passwordChange((showPassword) ? false : true)
    }

    //on change gender element
    let onChangeTitleElement = (genderElement) => { 
        changeTitlePopup(false)
        setTitleError(false)
        selectTitle(genderElement)
    } 

    //email on change element
    let onChangeEmailElement = (e) => {
        if(e.target.value !== ''){
            emailOnChange(true)
        }else{
            emailOnChange(false)
        }
    }

   

    let registrationSuccess = () => {    
        if(apiData.status){
            let loginData = apiData.doctor; 
            localStorage.setItem('doctor_user_details', JSON.stringify(loginData))
            localStorage.setItem('doctor_jwt_token', apiData.token)
            dispatch({
                    type: "SIGN_IN",
                    payload: loginData
            }) 
            dispatch({type: "API_LOADER_STOP"}) 
            dispatch({type: "API_DATA_DESTROY"}) 

            history.push("/dashboard");
        }
        
    }

    const aggreeConditionChange = () => {  
        if(privacyPolicAcceptInput.current.checked){
            setPrivacyPolicyError(false)
        }else{
            setPrivacyPolicyError(true)
        }
    }
 

    return ( 
        <>
        {
            (apiData.status) ? registrationSuccess() :  
            (apiData.message) ?   <ToastErrorMessage/> : null
        } 
        <div className="container-fluid bg-white mainDiv p-0 row ">
            
            <div className=" welcomeDiv  text-white ">
                <div className="login-logo text-lg-left text-md-left text-center px-3 ">
                <img src={ require('../assets/images/logo_final.png') } width="150" height="45" alt="img" className="mt-3  " />
                </div>
                <div className="text-center px-lg-5 mx-lg-2 px-md-4 mt-md-5 pt-md-1 pt-lg-0 px-2   ">
                    <h1 className="company_title ">Welcome</h1>
                    <span className="span px-2">Lorem Ipsum is simply dummy text of the
                            printing and typesetting industry</span>
                    <div className="d-flex justify-content-around mx-lg-3 mx-5 mx-md-5 pt-2"> 
                      <Link to="/"  className="loginbtn text-decoration-none">
                            Log in 
                      </Link>                    
                        <Link to="/register"  className="loginbtn text-decoration-none ml-3 disabled_button">
                            Register
                        </Link>    

                </div>
              </div>
            </div>

            <div className="centerArrowOutDiv">
                <div className="arrowIcon text-center d-none d-lg-block d-md-block d-xl-block">
                    <img src={ require('../assets/images/login_right_arrow.png') } alt="img" />
                </div>
            </div>

            <div className="  bg-white text-center loginDiv registerDiv">
             
              <h3 className="font-weight-normal mb-0">Register</h3>
              <Form className="text-center form mx-0 mx-lg-4 mx-md-4"  noValidate validated={formValidated} onSubmit={formSubmit}>  
                    
              <div className="select-box"> 
                <div className= {titlePopup ? "option-container active" : "option-container" }> 
                {
                    titleList.map((item, index) => 
                    <div className="option" key={'title-key'+index} onClick={ () => onChangeTitleElement(item)}>
                        <input type="radio" className="radio"  />
                        <label>{item}</label>
                    </div>
                    )
                }
                   
                    

                </div>
                <div className= { (titleError) ? "invalid-border-color selected" : "selected" } onClick={() => changeTitlePopup(true)}>
                    {title}
                </div>
                {
                    (titleError) ?
                        <div className="custom-form-error">
                            Select Title
                        </div>
                    :
                        null
                }
                
            </div> 


                    <main>
                        <InputGroup>  
                            <Form.Control
                                type="text" 
                                className="input-area"
                                name="name"
                                ref={firstNameInput}
                                required
                            />
                            <Form.Label className="label">Name*</Form.Label>
                            <Form.Control.Feedback type="invalid">
                                    Enter Name
                            </Form.Control.Feedback>  
                        </InputGroup>   
                    </main>

               
                    <main>
                        <PhoneInput
                        placeholder="Mobile number"
                        className="custom-phone-input"
                        label="Mobile number"
                        international
                        name="mobile_number"
                        defaultCountry="US" 
                        countryCallingCodeEditable={false} 
                        value={phoneNumber}
                        onChange={setPhoneNumber}/> 
                        <div className="invalid-feedback d-block">{phoneNumber ? (isValidPhoneNumber(phoneNumber) ? undefined : 'Invalid phone number') : 'Phone number required'}</div> 
                    </main>


                    <main>
                        <InputGroup>  
                            <Form.Control
                                type="email" 
                                className="input-area"
                                ref={emailInput}
                                onChange={ onChangeEmailElement } 
                                required
                            />
                            <Form.Label className={emailEntered ? "text-entered-label label" : "label" }>Email ID*</Form.Label>
                            <Form.Control.Feedback type="invalid">
                                    Enter Email ID
                            </Form.Control.Feedback>  
                        </InputGroup>   
                    </main>
 
                    <main>
                    <InputGroup> 
                        <i onClick={passwordToggle} className={showPassword ? 'input-password-icon fa fa-eye-slash' : 'input-password-icon fa fa-eye'}></i>
                        <Form.Control
                            type={showPassword ? 'text' : 'password'} 
                            ref={passwordInput}
                            className="input-area"
                            required
                        /> 
                        <Form.Label className="label">Password</Form.Label>
                        <Form.Control.Feedback type="invalid">
                                Enter Password
                        </Form.Control.Feedback>  
                    </InputGroup>  
                    </main>

                    <div className="py-2"> 
                        <label className="containerCheckBox float-left text-left" onClick={aggreeConditionChange} >I Agree to <a href="#">Terms & Conditions</a>
                            <input className="inputCheck" type="checkbox" ref={privacyPolicAcceptInput} required/>
                            <span className="checkmark"></span>
                        </label>
                        { (privacyPolicyError) ? <div class="invalid-feedback accept-privacy-policy-error">Accept Terms and Conditions</div> : null}
                        
                    </div>

                    <div className="py-3">
                      <button type="submit" className="loginbutton">
                         Register 
                      </button>
                    </div>
                </Form>
                </div>
                
            </div> 
        </>
    );
  }
  
  export default Register;